import { Injectable } from '@angular/core';
import {CanActivate} from '@angular/router';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '@service/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate{

    constructor(private router: Router, private authService: AuthenticationService) { }

    canActivate(): boolean {
        if(this.authService.loggedIn){
            return false;
        }
        return true;
    }

}